import paths from "routes/paths";

import AbstractApiActioner from "services/cores/abstractApiActioner";

import AvailableParkingActionTypes from "./types";
import AvailableParkingApi from "./api";
import AvailableParkingUtils from "./utils";

class AvailableParkingActioner extends AbstractApiActioner {}

export default new AvailableParkingActioner(
  "AvailableParking",
  AvailableParkingActionTypes,
  AvailableParkingApi,
  AvailableParkingUtils,
  {
    paths: {
      default: paths.api.parkStatistics.dataByRadius.availableParking,
      byAreas: paths.api.parkStatistics.dataByAreas.availableParking,
      byRadius: paths.api.parkStatistics.dataByRadius.availableParking,
    },
  }
);
